import React from 'react';
import { render } from '@testing-library/react';
import { Page } from './Page';
import { Layout } from '../Layout';

describe('Page', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Page data-auto-sel="automation-selector">
				<Layout type="support" autoSections={false} direction="left">
					<Layout.Section className="p-r-5">
						Lorem ipsum dolor sit amet
					</Layout.Section>
					<Layout.Section>Lorem ipsum dolor sit amet</Layout.Section>
				</Layout>
			</Page>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
